import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import { Link as RouterLink } from 'react-router-dom'
import ChevronRightIcon from 'components/material-symbol/icons/ChevronRight'
import useStyles from './styles'

const AccountLinkRow = ({ href, to, icon, title, description }) => {
  const classes = useStyles()
  const content = (
    <>
      <Box className={classes.iconWrap}>{icon}</Box>
      <Box className={classes.copy}>
        <Typography className={classes.title}>{title}</Typography>
        <Typography className={classes.caption}>{description}</Typography>
      </Box>
      <ChevronRightIcon className={classes.chevron} />
    </>
  )

  if (to) {
    return (
      <RouterLink to={to} className={classes.link}>
        {content}
      </RouterLink>
    )
  }

  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      underline="none"
      className={classes.link}
    >
      {content}
    </Link>
  )
}

AccountLinkRow.propTypes = {
  href: PropTypes.string,
  to: PropTypes.string,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}

export default AccountLinkRow
